import React from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import { AutoComplete } from '@components/common'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import CloseIcon from '@material-ui/icons/Close'

const styles = {
  root: {
    position: 'absolute',
    background: 'white',
    padding: '20px',
    width: '528px',
    height: '430px',
    borderRadius: '10px',
    boxShadow: '1px 1px 5px 1px grey',
    minHeight: '360px',
    marginTop: '2px'
  },
  filter_label: {
    marginTop: '10px'
  },
  filter_projects_actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '8px'
  },
  clearBtn: {
    border: 'unset',
    color: 'gray'
  },
  searchBtn: {
    color: 'white',
    border: 'solid 1px transparent',
    borderRadius: '5px',
    padding: '8px 20px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    backgroundColor: '#1E88E5',
    marginLeft: '30px'
  },
  close_filter_dropdown: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  filter_close_button: {
    cursor: 'pointer'
  }
}
export class FilterProjects extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      propertyName: '',
      city: null,
      owner: null,
      dealNumber: ''
    }
  }

  updateFilterProps = (key, value) => {
    this.setState({
      ...this.state,
      [key]: value
    })
  }

  clearFilters = () => {
    this.setState({
      propertyName: '',
      city: null,
      owner: null,
      dealNumber: ''
    })
  }

  searchProjectFilter = () => {
    const { propertyName, city, owner, dealNumber } = this.state
    if (propertyName || city || owner || dealNumber) {
      this.props.filterChange({ propertyName, city, owner: owner?.entity_guid, dealNumber })
    }
  }

  onCityTextChangeHandler = text => {
    this.props.getCities(text)
  }

  onOwnerTextChangeHandler = text => {
    this.props.getUsers(text)
  }

  render() {
    const { classes, citylookUp, ownerlookUp, toogleFilterProjectsDialog } = this.props

    const { propertyName,
      city,
      owner,
      dealNumber
    } = this.state

    const { updateFilterProps,
      searchProjectFilter,
      clearFilters
    } = this

    return (
      <Paper
        data-testid="projects_filter_dialog"
        classes={{ root: classes.root }}
        aria-labelledby="project_filter"
      >
        <div>
          <div
            name="form_filter"
            data-testid="filter_projects"
          >
            <div className={classes.close_filter_dropdown}>
              <CloseIcon
                  data-testid={'close_filter_dropdown'}
                  onClick={() => toogleFilterProjectsDialog()}
                  className={classes.filter_close_button}
                />
            </div>
            <div className={classes.filter_label}>Subject Property Name</div>
            <TextField
              variant="outlined"
              autoFocus
              margin="dense"
              name="propertyName"
              type="text"
              fullWidth
              value={propertyName}
              inputProps={{ 'data-testid': 'project_name' }}
              onChange={event => updateFilterProps('propertyName', event.target.value)}
            />

            <div className={classes.filter_label}>Deal Number</div>
            <TextField
              variant="outlined"
              margin="dense"
              name="dealNumber"
              type="number"
              fullWidth
              value={dealNumber}
              inputProps={{ 'data-testid': 'deal_number' }}
              onChange={event => updateFilterProps('dealNumber', event.target.value)}
              onInput = {e => {
                e.target.value = Math.max(0, parseInt(e.target.value, 10))
                  .toString()
                  .slice(0, 9)
              }}
            />

            <div className={classes.filter_label}>City</div>
            <AutoComplete
              onTextChangeHandler={this.onCityTextChangeHandler}
              onSelectedHandler={value => updateFilterProps('city', value)}
              displayOptions={citylookUp}
              getOptionLabel={option => option}
              getOptionSelected={(option, value) => option === value}
              value={city}
              name="city"
            />

            <div className={classes.filter_label}>Owner</div>
            <AutoComplete
              onTextChangeHandler={this.onOwnerTextChangeHandler}
              onSelectedHandler={value => updateFilterProps('owner', value)}
              displayOptions={ownerlookUp}
              getOptionLabel={option => option.user_name}
              getOptionSelected={(option, value) => option.user_name === value.user_name}
              value={owner}
              name="Owner"
            />

            <div className={classes.filter_projects_actions}>
              <Button
                data-testid="filter_projects_clear"
                onClick={clearFilters}
                className={classes.clearBtn}
              >
                Clear
              </Button>
              <Button
                data-testid="filter_projects_submit"
                variant="contained"
                color="primary"
                onClick={searchProjectFilter}
                className={classes.searchBtn}
                disabled={!(propertyName || city || owner?.entity_guid || owner?.user_name || owner?.email || dealNumber)}
              >
                Search
              </Button>
            </div>
          </div>
          <div>
          </div>
        </div>
      </Paper>
    )
  }
}

FilterProjects.propTypes = {
  classes: PropTypes.object,
  filterChange: PropTypes.func,
  citylookUp: PropTypes.array,
  ownerlookUp: PropTypes.array,
  getCities: PropTypes.func,
  getUsers: PropTypes.func,
  toogleFilterProjectsDialog: PropTypes.func
}

const mapStateToProps = state => ({
  citylookUp: Comps.selectors.comps.citylookUp(state),
  ownerlookUp: Comps.selectors.comps.ownerlookUp(state)
})

const mapDispatchToProps = {
  getCities: Comps.actions.getCities,
  getUsers: Comps.actions.getUsers
}

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterProjects))


